import { Box, Typography, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import React from 'react';
import { FadedPaper } from '../../theme/StyledFields';

interface Props {
    organizationName: string;
    reportDate: string;
    planCount: number;
    athleteCount: number;
}

const SessionEngagementHeader: React.FC<Props> = ({ organizationName, reportDate, planCount, athleteCount }) => (
    <FadedPaper sx={{ p: 3, mb: 3 }} data-testid="engagement-header">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                    Session Engagement Report
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {organizationName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Report Date: {reportDate} &bull; {athleteCount} athletes &bull; {planCount} lesson plans
                </Typography>
            </Box>
            <Button
                variant="outlined"
                startIcon={<PrintIcon />}
                onClick={() => window.print()}
                className="no-print"
            >
                Print
            </Button>
        </Box>
    </FadedPaper>
);

export default SessionEngagementHeader;
